let canvas: HTMLCanvasElement | null = null;
let context: CanvasRenderingContext2D | null = null;


export const measureTextLines = (s: string, font: string, width: number): number => {
  if (!canvas) {
    canvas = document.createElement('canvas');
    context = canvas.getContext('2d');
  }
  if (!context) {
    return 0;
  }
  context.font = font;
  let h = 0;
  s.split('\n').forEach((subStr) => {
    if (!context) {
      h += 1;
      return;
    }
    const w = context.measureText(subStr).width;
    h += Math.floor(w / width) + 1;
  });
  return h;
};
